import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { ThemeProvider } from '@material-ui/core/styles'

import overrideTheme from 'theming/overrides/dashboard/sectionList'

const SectionList = ({ children, className }) => (
  <ThemeProvider theme={overrideTheme}>
    <Table className={className}>
      <TableBody>{children}</TableBody>
    </Table>
  </ThemeProvider>
)

SectionList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default SectionList
